import type { HTMLProps, Ref } from 'react';
import { mergeClassnames } from '@heathmont/moon-core-tw';
import NextLink from './NextLink';

type Props = HTMLProps<HTMLAnchorElement> & {
  secondary?: boolean;
  disabled?: boolean;
  ref?: Ref<HTMLAnchorElement>;
};

const SimpleLink: FC<Props> = ({
  children,
  className,
  secondary,
  disabled,
  href = '',
  ...props
}) => {
  const Link = href ? NextLink : 'a';
  return (
    <Link
      {...props}
      href={href}
      className={mergeClassnames(
        'inline cursor-pointer bg-transparent p-0 font-[inherit] text-piccolo no-underline',
        className,
        secondary && 'text-trunks hover:text-piccolo',
        disabled && 'cursor-not-allowed opacity-30 hover:text-inherit',
      )}
    >
      {children}
    </Link>
  );
};

export default SimpleLink;
